import * as React from 'react';
import FormListItem from 'components/Form/List/FormListItem';
import ControlInputWithoutClass from 'components/Form/Input/ControlInputWithoutClass';
import IRegisterFormLabels from 'components/Customer/Interfaces/IRegisterFormLabels';
import { FormikValues } from 'formik/dist/types';
import ISelectField from 'components/Customer/Interfaces/ISelectField';
import IRegionSelect from 'components/Customer/Interfaces/IRegionSelect';

export interface ICustomerCompanyForm {
    labels: IRegisterFormLabels;
    countrySelectConfig: ISelectField;
    regionSelectConfig: IRegionSelect;
    formik: FormikValues;
}

const CustomerCompanyForm = (props: ICustomerCompanyForm) => {
    const { labels, formik, countrySelectConfig, regionSelectConfig } = props;

    return (
        <React.Fragment>
            <h3>{labels.companyInfoHeadingLabel}</h3>
            <input id="create_address" type="hidden" name="create_address" value={1} />
            <FormListItem
                label={labels.companyNameLabel}
                required={formik.values.is_company}
                error={formik.errors.company}
            >
                <ControlInputWithoutClass
                    name="company"
                    value={formik.values.company ?? ''}
                    onChange={formik.handleChange}
                />
            </FormListItem>
            <FormListItem
                label={labels.companyRegNumberLabel}
                required={formik.values.is_company}
                error={formik.errors.vat_id}
            >
                <ControlInputWithoutClass
                    name="vat_id"
                    value={formik.values.vat_id ?? ''}
                    onChange={formik.handleChange}
                />
            </FormListItem>
            <FormListItem
                label={labels.companyPhoneLabel}
                required={formik.values.is_company}
                error={formik.errors.telephone}
            >
                <ControlInputWithoutClass
                    name="telephone"
                    value={formik.values.telephone ?? ''}
                    onChange={formik.handleChange}
                />
            </FormListItem>
            <h3>{labels.companyAddressHeadingLabel}</h3>
            <FormListItem
                label={labels.companyStreetAddressLabel}
                required={formik.values.is_company}
                error={formik.errors.street}
            >
                <ControlInputWithoutClass
                    name="street"
                    value={formik.values.street ?? ''}
                    onChange={formik.handleChange}
                />
            </FormListItem>
            {countrySelectConfig && (
                <React.Fragment>
                    <FormListItem
                        label={labels.companyCountryLabel}
                        required={formik.values.is_company}
                        error={formik.errors.country_id}
                    >
                        <select
                            value={formik.values.country_id}
                            onChange={(e) => {
                                formik.setFieldValue('country_id', e.target.value);
                            }}
                            required={formik.values.is_company}
                        >
                            {countrySelectConfig.options.map((countryOption) => {
                                return (
                                    <option key={countryOption.value + countryOption.label} value={countryOption.value}>
                                        {countryOption.label}
                                    </option>
                                );
                            })}
                        </select>
                    </FormListItem>
                    <input type="hidden" value={formik.values.country_id} name="country_id" />
                </React.Fragment>
            )}
            {regionSelectConfig && (
                <FormListItem
                    label={labels.companyRegionLabel}
                    required={formik.values.is_company}
                    error={formik.errors.region}
                >
                    <select
                        disabled={regionSelectConfig.disabled}
                        placeholder={regionSelectConfig.default}
                        value={formik.values.region_id ?? ''}
                        onChange={(e) => {
                            formik.setFieldValue('region', e.target.options[e.target.selectedIndex].text);
                            formik.setFieldValue('region_id', e.target.value);
                        }}
                        required={formik.values.is_company}
                    >
                        {regionSelectConfig.default && <option value="">{regionSelectConfig.default}</option>}
                        {regionSelectConfig.options.map((regionOption) => {
                            return (
                                <option key={regionOption.value + regionOption.label} value={regionOption.value}>
                                    {regionOption.label}
                                </option>
                            );
                        })}
                    </select>
                    <input type="hidden" value={formik.values.region_id} name="region_id" />
                    <input type="hidden" value={formik.values.region} name="region" />
                </FormListItem>
            )}
            <FormListItem
                label={labels.companyCityLabel}
                required={formik.values.is_company}
                error={formik.errors.city}
            >
                <ControlInputWithoutClass name="city" value={formik.values.city ?? ''} onChange={formik.handleChange} />
            </FormListItem>
            <FormListItem
                label={labels.companyZipLabel}
                required={formik.values.is_company}
                error={formik.errors.postcode}
            >
                <ControlInputWithoutClass
                    name="postcode"
                    value={formik.values.postcode ?? ''}
                    onChange={formik.handleChange}
                />
            </FormListItem>
            <input type="hidden" name="default_billing" value="1" />
        </React.Fragment>
    );
};

export default CustomerCompanyForm;
